import Interviewer from '@/orm/models/Interview/Interviewer';
import { computed } from '@vue/composition-api';

export default function useInterviewer() {
  const interviewers = computed(() => Interviewer.query().withAllRecursive().all());

  async function fetchInterviewers() {
    await Interviewer.api().fetchAll();
  }

  return {
    fetchInterviewers,
    interviewers,
  };
}
